import { Reducer } from "redux";

import { MasterServiceProviderResponse } from "../models/api/ServiceProvider";
import { MasterServiceProviderDefaultActionDispatchTypes } from "../constants/ServiceProvider";
import { MasterServiceProviderDefaultDispatchTypes } from "../models/dispatchTypes/ServiceProvider";

const initialState: MasterServiceProviderResponse = {
  loading: false,
  response: [],
  error: null
};

const MasterServiceProviderDefaultReducer: Reducer<
  MasterServiceProviderResponse,
  MasterServiceProviderDefaultDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterServiceProviderDefaultActionDispatchTypes.MASTER_SERVICE_PROVIDER_DEFAULT_INVOKE: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case MasterServiceProviderDefaultActionDispatchTypes.MASTER_SERVICE_PROVIDER_DEFAULT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: null,
      };
    }
    case MasterServiceProviderDefaultActionDispatchTypes.MASTER_SERVICE_PROVIDER_DEFAULT_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
  }
  return state;
};

export default MasterServiceProviderDefaultReducer;
